module.exports = __webpack_public_path__ + "img/tpc-24.1bcb6f6f.jpg";